<app-default-layout
  [title]="'AUTHENTICATION.EMAIL_AENDERN.TITLE'"
  [subtitle]="'AUTHENTICATION.EMAIL_AENDERN.SUBTITLE'"
>


  <div class="row">
    <div class="col-md-8 offset-md-2">
      <form  [formGroup]="mailAenderungForm" (ngSubmit)="this.save()" class="form-horizontal"
             accept-charset="UTF-8">
        <div class="form-group group-for-email col mb-4">

          <div class="d-flex flex-row" style="margin-bottom: -15px">
            <div class="flex-grow-1 mr-2">
              <app-custom-input id="email" type="text"
                                class="flex-grow-1"
                                label="{{'STANDARD.EMAIL_NEU' |translate }}"
                                [customFormGroup]="mailAenderungForm"
                                [readonly] = "true"
              ></app-custom-input>
            </div>
          </div>
        </div>

        <div class="form-group group-for-kennwort col mb-4">
          <div class="d-flex flex-row" style="margin-bottom: -15px">
            <div class="flex-grow-1 mr-2">
              <app-custom-input id="kennwort" type="text"
                                [type] = "pwHide? 'password':'text'"
                                class="flex-grow-1"
                                label="{{'REGISTRIERUNG.PW' |translate }}"
                                [customFormGroup]="mailAenderungForm">
              </app-custom-input>
            </div>
            <fa-icon  style="margin-left: -25px; padding-top: 17px; margin-top: 15px; width: 26px; z-index:1"
                      [icon]="pwHide? faEye:faEyeSlash" (click) = "pwHide=!pwHide"
                      [title]="pwHide? translate.instant('LOGIN.PW-SHOW'):translate.instant('LOGIN.PW-HIDE')"
                      data-cy="btn-pwhide">
            </fa-icon>
          </div>
        </div>

        <button type="submit"
                class="btn btn-primary save btn-block me-3"
                data-cy="btn-submit">
          {{'APPLICATION.BUTTON_SPEICHERN'|translate}}
        </button>

      </form>
    </div>
  </div>


</app-default-layout>
